import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Product, Warehouse } from 'src/typings';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-product-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() product: Product | null = null;

  @Input() defaultWarehouse: Warehouse | null = null;

  @Output() updateProductEvent = new EventEmitter<Product>();

  analogies: MatTableDataSource<Product> = new MatTableDataSource();

  constructor(private productService: ProductService) {}

  ngOnInit(): void {
    if (this.product)
      this.productService.getAnalogues(this.product.id).subscribe((list) => {
        this.analogies = new MatTableDataSource(list);
      });
  }

  createTableDataSource(): MatTableDataSource<Product> {
    return new MatTableDataSource(this.product?.analogue_folder?.products);
  }

  productChanges(product: Product) {
    this.updateProductEvent.emit(product);
  }
}
